import { render, staticRenderFns } from "./BookmakerPromotionCreate.vue?vue&type=template&id=15ac030e&"
import script from "./BookmakerPromotionCreate.vue?vue&type=script&lang=ts&"
export * from "./BookmakerPromotionCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports